'use client';

import React, { FC, useState, useEffect } from 'react';
import { TypeGlobalNavFields } from '@/core/generated-types';
import { LargeNav } from './LargeNav/LargeNav';
import { SmallNav } from './SmallNav/SmallNav';
import { MessageBanner } from './MessageBanner/MessageBanner';
import { FeatureFlag } from '@/core/featureFlags';
import useFeature from '@/hooks/useFeature';

export const GlobalNav: FC<TypeGlobalNavFields> = (props) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const isNavigationRedesign = useFeature(FeatureFlag.SUB_SQUAD_NAV_REDESIGN);

  useEffect(() => {
    const onScroll = () => {
      const { scrollTop } = window.document.documentElement;
      if (scrollTop <= 0 && isScrolled) {
        setIsScrolled(false);
      } else if (scrollTop > 0 && !isScrolled) {
        setIsScrolled(true);
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [isScrolled]);

  if (!isNavigationRedesign) {
    return null;
  }

  const shouldShowBanner = props.bannerMessage || props.showAccessibilityLink;

  return (
    <>
      {shouldShowBanner && (
        <MessageBanner
          showAccessibilityLink={props.showAccessibilityLink}
          enableAccessibilityLabel={props.enableAccessibilityLabel}
          disableAccessibilityLabel={props.disableAccessibilityLabel}
          bannerMessage={props.bannerMessage}
          bannerLinks={props.bannerLinks}
        />
      )}
      <LargeNav {...props} isScrolled={isScrolled} />
      <SmallNav {...props} isScrolled={isScrolled} />
    </>
  );
};

export default React.memo(GlobalNav);
